const { mainConfigService } = require('../services/config');
const { SDK_FOPS } = require('../variables');
const pkg = require('../../../package.json');

// Mirror jazz_sdk validateAndGetIframeUrls: parse the ottu_pg direct payment
// URL and return its origin (trailing slash stripped). '' on any failure.
function derivePgOrigin(directPaymentUrl) {
  try {
    if (!directPaymentUrl) {
      return '';
    }
    return new URL(directPaymentUrl).origin.replace(/\/$/, '');
  } catch (e) {
    return '';
  }
}

function buildContext(scriptElement = null) {
  const hasWindow = typeof window !== 'undefined' && !!window.location;
  const merchant_id = mainConfigService.get('merchant_id') || '';
  const rawPaymentMethods = mainConfigService.get('payment_methods');
  const paymentMethods = Array.isArray(rawPaymentMethods) ? rawPaymentMethods : [];
  const ottuPgMethod = paymentMethods.find((m) => m && m.flow === SDK_FOPS.OTTU_PG && m.direct_payment_url) || null;
  const directPaymentUrl = ottuPgMethod ? (ottuPgMethod.direct_payment_url || '') : '';
  return {
    sdkVersion: pkg.version,
    merchant_id,
    session_id: mainConfigService.get('session_id') || null,
    apiKey: mainConfigService.get('apiKey') || '',
    selector: mainConfigService.get('selector') || '',
    lang: mainConfigService.get('lang') || null,
    setupPreload: mainConfigService.get('setupPreload') || null,
    shopOrigin: hasWindow ? (window.location.origin || '') : '',
    ottuInstanceDomain: merchant_id,
    paymentMethods,
    directPaymentUrl,
    pgOrigin: derivePgOrigin(directPaymentUrl),
    scriptElement,
  };
}

module.exports = { buildContext, derivePgOrigin };
